function attachScript(path) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.onload = function () {
      resolve(script);
    };
    script.src = path;
    script.type = "text/javascript";
    document.body.appendChild(script);
  });
}

async function loadDependencies() {
  await import("./js/app.js");
  await import("./js/app.main.js");
  await import("./app.bootstrap.js");
  // dynamically load config
  const configScript = document.createElement("script");
  return new Promise((resolve, reject) => {
    configScript.onload = function () {
      attachScript("js/directives.js").then(() => {
        return attachScript("js/views.js");
      }).then(() => {
        resolve();
      });
    };
    configScript.src = "/config/config.js";
    document.head.appendChild(configScript);
  });
}

async function loadPreloadedDependencies() {
  await import("./stylesheets.js");
  await import("./../scss/main.scss");
  await import("./../src/styles/styles.scss");
}

import angular from 'angular';
window.angular = angular;
require("./main.dependencies.js");
import '@angular/compiler';
import { AppModule, bindToAngularJs } from "../src/app.module.ts";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { UIRouter } from '@uirouter/core';
import 'zone.js';
import { NgZone } from '@angular/core';

(async () => { 
  await loadPreloadedDependencies();
  await loadDependencies();
  // import all downgraded Angular dependencies
  bindToAngularJs(window.app);

  // Using AngularJS config block, call `deferIntercept()`.
  // This tells UI-Router to delay the initial URL sync (until all bootstrapping is complete)
  window.app.config([ '$urlServiceProvider', ($urlService) => $urlService.deferIntercept() ]);
  platformBrowserDynamic().bootstrapModule(AppModule).then(ref => {
    // Intialize the Angular Module
    // get() the UIRouter instance from DI to initialize the router
    const urlService = ref.injector.get(UIRouter).urlService;

    // Instruct UIRouter to listen to URL changes
    function startUIRouter() {
      urlService.listen();
      urlService.sync();
    }

    ref.injector.get(NgZone).run(startUIRouter);
  });
})();
